"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerPreferencesConcurrentUpdateError = exports.MissingTaskIdInAvatarError = exports.TaskAlreadyCompletedError = exports.WorkerAddressNotAvailableError = exports.GenderNotAllowedError = exports.AvatarExtrasMatchWorkerAddressError = exports.ProfileInvalidError = exports.ProfileNotValidatedError = exports.AccesscodePhonenumberMismatchError = exports.UniqueTaskAvatarConflictError = exports.UniqueDeviceAvatarConflictError = exports.UniqueProjectAvatarConflictError = exports.AvatarLinkedToAnotherWorkerError = exports.UnAuthorizedAccessError = exports.InvalidAccessCodeError = void 0;
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
const error_values_1 = require("@karya/error-values");
// Invalid avatar code errors
class InvalidAccessCodeError extends error_values_1.CodedError {
    constructor() {
        super('InvalidAccessCodeError', 'Access code is invalid', {});
    }
}
exports.InvalidAccessCodeError = InvalidAccessCodeError;
// UnAuthorized Access to avatar error
class UnAuthorizedAccessError extends error_values_1.CodedError {
    constructor() {
        super('UnAuthorizedAccessError', 'User is UnAuthorized to use this AccessCode', {});
    }
}
exports.UnAuthorizedAccessError = UnAuthorizedAccessError;
// Avatar linked to another worker error
class AvatarLinkedToAnotherWorkerError extends error_values_1.CodedError {
    constructor() {
        super('AvatarLinkedToAnotherWorkerError', 'Avatar is already linked to another worker', {});
    }
}
exports.AvatarLinkedToAnotherWorkerError = AvatarLinkedToAnotherWorkerError;
// Worker has another avatar for the same project
class UniqueProjectAvatarConflictError extends error_values_1.CodedError {
    constructor() {
        super('UniqueProjectAvatarConflictError', 'Worker has another avatar for the same project', {});
    }
}
exports.UniqueProjectAvatarConflictError = UniqueProjectAvatarConflictError;
class UniqueDeviceAvatarConflictError extends error_values_1.CodedError {
    constructor() {
        super('UniqueDeviceAvatarConflictError', 'This device has already been used for a task in this task group.', {});
    }
}
exports.UniqueDeviceAvatarConflictError = UniqueDeviceAvatarConflictError;
// Worker has another avatar for the same task
class UniqueTaskAvatarConflictError extends error_values_1.CodedError {
    constructor() {
        super('UniqueTaskAvatarConflictError', 'Worker has another avatar for the same task', {});
    }
}
exports.UniqueTaskAvatarConflictError = UniqueTaskAvatarConflictError;
class AccesscodePhonenumberMismatchError extends error_values_1.CodedError {
    constructor() {
        super('AccesscodePhonenumberMismatchError', `AccessCode can't be used by this phonenumber`, {});
    }
}
exports.AccesscodePhonenumberMismatchError = AccesscodePhonenumberMismatchError;
class ProfileNotValidatedError extends error_values_1.CodedError {
    constructor() {
        super('ProfileNotValidatedError', 'Your Profile is Not Validated Yet or Under Review', {});
    }
}
exports.ProfileNotValidatedError = ProfileNotValidatedError;
class ProfileInvalidError extends error_values_1.CodedError {
    constructor() {
        super('ProfileInvalidError', 'Your Profile Data is Invalid. Ask the Coordinator to enter again.', {});
    }
}
exports.ProfileInvalidError = ProfileInvalidError;
class AvatarExtrasMatchWorkerAddressError extends error_values_1.CodedError {
    constructor(message) {
        super('AvatarExtrasMatchWorkerAddressError', message !== null && message !== void 0 ? message : 'Avatar Extras does not match Worker Address', {});
    }
}
exports.AvatarExtrasMatchWorkerAddressError = AvatarExtrasMatchWorkerAddressError;
class GenderNotAllowedError extends error_values_1.CodedError {
    constructor(message) {
        super('GenderNotAllowedError', message !== null && message !== void 0 ? message : 'Apologies. Currently we are not allowing any new registrations of this gender for this Task', {});
    }
}
exports.GenderNotAllowedError = GenderNotAllowedError;
class WorkerAddressNotAvailableError extends error_values_1.CodedError {
    constructor() {
        super('WorkerAddressNotAvailableError', 'Worker Address is not available', {});
    }
}
exports.WorkerAddressNotAvailableError = WorkerAddressNotAvailableError;
class TaskAlreadyCompletedError extends error_values_1.CodedError {
    constructor() {
        super('TaskAlreadyCompletedError', 'Cannot Link: This avatar belongs to a task that is already completed', {});
    }
}
exports.TaskAlreadyCompletedError = TaskAlreadyCompletedError;
class MissingTaskIdInAvatarError extends error_values_1.CodedError {
    constructor(details) {
        const errMessage = `[${details.contextName}] The avatar was expected to have a task id, but it does not`;
        super('MissingTaskIdInAvatarError', errMessage, details);
    }
}
exports.MissingTaskIdInAvatarError = MissingTaskIdInAvatarError;
class WorkerPreferencesConcurrentUpdateError extends error_values_1.CodedError {
    constructor() {
        super('WorkerPreferencesConcurrentUpdateError', 'Preferences were updated concurrently. Please retry.', {});
    }
}
exports.WorkerPreferencesConcurrentUpdateError = WorkerPreferencesConcurrentUpdateError;
//# sourceMappingURL=worker.js.map